import { type merged_time_and_activity } from '@common/@types/prisma';
import { getLearningSessionDisplay } from '@common/components/daily-activity/formatters/learningSession/RadialGaugeLearningSessionFormatter';
import { StudentGoalView } from '@common/utils/amplify/getStudentGoalByStudentId';

import { WORKING_DAYS } from '../../constants';
import {
  type StudentDayStats,
  type StudentWeeklyStats,
  type SubjectLevelPersonalGoal,
} from '../../model';
import { getPercetageValue } from '../../utils';
import { getDayName } from './dateTimeUtils';

/*
  Map server response for ui representation
*/
export const getStudentWeeklyStatsGroupedBySubject = (
  data: Array<merged_time_and_activity> | undefined,
  theme: any
): StudentWeeklyStats => {
  const results: StudentWeeklyStats = {};

  if (!data || !data.length) {
    return results;
  }

  for (let i = 0; i < data.length; i++) {
    const { date, subject } = data[i];
    const dayName = getDayName(date);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [timeSpent, accuracy, correctQuestionsPersHour, mastery] = getLearningSessionDisplay(
      data[i],
      theme
    );

    const { actual, target } = mastery;

    const stats: StudentDayStats = {
      actual,
      target,
      completedPercentage: getPercetageValue(target, actual),
      mastered: actual >= target,
    };

    results[subject] = {
      ...results[subject],
      [dayName]: stats,
    };
  }

  return results;
};

/**
 * Return student personal goal per subject
 */
export const getStudentPeronsoalGoalMapBySubjects = (
  data: StudentGoalView[] | undefined
): SubjectLevelPersonalGoal => {
  const results: SubjectLevelPersonalGoal = {};

  if (!data) {
    return results;
  }

  for (const item of data) {
    const { subject, currentPace } = item;

    if (!currentPace || currentPace <= 0) {
      continue;
    }

    results[subject] = currentPace;
  }

  return results;
};

/**
 * Return data mapped by current day. if its Saturday or sunday, return Fridays data.
 */
export const getCurrentDayData = (
  day: string,
  data: Record<string, StudentDayStats> | undefined
): StudentDayStats | null => {
  if (!data) {
    return null;
  }

  if (WORKING_DAYS.includes(day)) {
    return data[day];
  }
  return {
    ...data['Friday'],
    target: 0,
  };
};
